<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#ffffff">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
</template>

<script>
export default {
  name: 'Checkmark'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/Checkmark.vue